import React from 'react'
import { graphql, Link } from 'gatsby';
import SEO from '../components/SEO';
import Layout from '../components/layout';

export default ({ data }) => {
  let groups = data.allGiinsYaml ? data.allGiinsYaml.group.slice(0) : [];
  groups.sort((group1, group2) => {
    return group2.totalCount - group1.totalCount;
  });
   return (
    <Layout>
      <SEO title='会派紹介'/>
      <h2>会派紹介</h2>
      <div>
        <ul>
          {groups.map(({ fieldValue }) => {
            const edge = data.allGroupsYaml.edges.find(({node}) => { return node.identifier === fieldValue; });
            if(edge) {
              const group = edge.node;
              return <li key={group.identifier}><Link to={`/groups/${group.identifier}`}>{group.name}</Link></li>;
            } else {
              return null;
            }
          })}
        </ul>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query {
    allGiinsYaml(filter: {fields: {currentGroup: {ne: ""}}}) {
      group(field: fields___currentGroup) {
        totalCount
        fieldValue
      }
    }
    allGroupsYaml {
      edges {
        node {
          identifier
          name
        }
      }
    }
  }
`;